import { theme } from '@faxi/web-component-library';
import { flex, fontSize, laptop, phablet } from '@faxi/web-css-utilities';
import styled, { css } from 'styled-components';

const StyledSplashSection = styled.section`
  ${flex('column', 'flex-end', 'stretch')};
  gap: ${theme.sizes.SIZE_104};

  background: url('/webp/hero.webp') no-repeat fixed;
  background-size: cover;
  padding: ${theme.sizes.SIZE_80} ${theme.sizes.SIZE_80} ${theme.sizes.SIZE_200};
  min-height: 100vh;

  ${laptop(css`
    gap: ${theme.sizes.SIZE_80};
  `)};

  ${phablet(css`
    ${flex('column', 'center', 'stretch')};
    gap: ${theme.sizes.SIZE_48};

    padding: ${theme.sizes.SIZE_96} ${theme.sizes.SIZE_20}
      ${theme.sizes.SIZE_32};

    > div {
      flex-grow: 1;
    }
  `)};

  .cedolauto-splash {
    &__heading {
      ${flex('column', 'center')};
      flex-grow: 1;

      &__title {
        margin: 0;
        color: var(--BACKGROUND_2_1);

        ${fontSize('80px')};

        ${laptop(css`
          ${fontSize('72px')};
        `)};

        ${phablet(css`
          ${fontSize('46px')};
        `)};
      }

      &__description {
        background-color: var(--PRIMARY_1_1);
        color: black;

        padding: ${theme.sizes.SIZE_6} ${theme.sizes.SIZE_32};
        border-radius: ${theme.sizes.SIZE_8};

        font-weight: 500;
        width: fit-content;

        ${fontSize(theme.fontSizes.FONT_24, '40px')};
        margin: ${theme.sizes.SIZE_10} 0 0 0;

        ${phablet(css`
          ${fontSize(theme.fontSizes.FONT_18, '28px')};
          max-width: 600px;
        `)};
      }
    }

    &__content {
      ${flex('row', 'space-between', 'flex-end')};
      gap: ${theme.sizes.SIZE_24};

      ${laptop(css`
        ${flex('column', 'space-between')};
        gap: ${theme.sizes.SIZE_104};
      `)}

      &__powered-by {
        p {
          ${fontSize(theme.fontSizes.FONT_24)};
          color: white;
          text-transform: uppercase;

          ${phablet(css`
            ${fontSize(theme.fontSizes.FONT_16)};
          `)}
        }

        &__logo {
          width: ${theme.sizes.SIZE_376};

          ${phablet(css`
            width: ${theme.sizes.SIZE_200};
          `)};
        }
      }
    }
  }
`;

export { StyledSplashSection };
